import { Box } from '@chakra-ui/react';
import { Avatar } from '@/components/ui/avatar';
import { resolveEntityLogoUrl } from '../utils/staticUrl.js';

/**
 * Logo de banda/cofradía en tarjetas: círculo centrado (como el avatar del perfil),
 * sin estirar al rectángulo superior (evita redimensiones y fondos raros).
 */
export default function EntityLogoImage({
  src,
  alt = '',
  name,
  h = '200px',
  w = 'full',
  /** Diámetro del círculo del logo */
  circleSize = '150px',
  bg = 'gray.50',
}) {
  const resolved = resolveEntityLogoUrl(src);
  const label = name || alt || '';

  return (
    <Box
      position="relative"
      w={w}
      h={h}
      bg={bg}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      <Avatar.Root
        boxSize={circleSize}
        bg="white"
        borderWidth="1px"
        borderColor="blackAlpha.100"
        shadow="sm"
      >
        <Avatar.Fallback name={label} />
        {resolved ? <Avatar.Image src={resolved} alt={alt || label} /> : null}
      </Avatar.Root>
    </Box>
  );
}
